import React from 'react';
import PreInterviewComponent from 'src/components/interviews/PreInterviewComponent';

const PifProfileEdit = () => {
	return (
		<div>
			<PreInterviewComponent fromEditProfile={true} />
		</div>
	);
};

export default PifProfileEdit;
